import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana92Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <rect width="1221" height="921" fill="url(#pattern0_1461_7549)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M309.988 502.769L339.105 489.528L358.966 533.223L319.243 551.76L304.692 518.658C301.514 510.184 306.898 504.535 309.988 502.769Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M337.796 594.135L319.258 551.765L358.981 533.228L381.49 582.219L352.36 595.459C346.005 599.696 340.002 596.342 337.796 594.135Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M419.891 563.678L381.493 582.215L358.983 533.224L397.382 514.687L419.891 563.678Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M456.965 545.139L419.89 563.676L397.381 514.685L434.455 497.472L456.965 545.139Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M494.034 527.931L456.96 545.144L434.451 497.477L470.201 480.264L494.034 527.931Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M509.925 461.729L470.203 480.266L494.036 527.933L532.434 509.395L509.925 461.729Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M546.998 444.515L509.923 461.728L532.433 509.395L569.507 490.858L546.998 444.515Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M585.397 425.972L546.998 444.509L569.508 490.852L606.582 472.315L585.397 425.972Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M620.929 465.141L606.581 472.315L585.396 425.972L639.683 399.49C643.392 427.303 634.523 448.692 627.814 459.219C626.156 461.82 623.688 463.761 620.929 465.141Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M623.799 359.772C633.332 374.602 638.364 392.433 639.688 399.495L602.614 418.031L581.428 373.013C586.283 370.365 598.112 364.009 606.586 359.772C615.06 355.535 621.592 358.007 623.799 359.772Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M541.702 392.871L581.425 373.01L602.61 418.029L562.888 436.566L541.702 392.871Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M500.655 412.733L541.702 392.872L562.887 436.567L521.841 456.428L500.655 412.733Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M460.938 431.27L500.661 412.732L521.846 456.427L482.123 474.964L460.938 431.27Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M421.212 449.81L460.934 431.272L482.12 474.967L441.073 493.504L421.212 449.81Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M381.493 469.673L421.215 449.812L441.076 493.506L400.03 513.367L381.493 469.673Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M381.49 469.673L339.119 489.534L358.98 533.229L400.027 513.368L381.49 469.673Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1461_7549" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1461_7549" transform="matrix(0.0018162 0 0 0.00240779 -3.84523 -1.63987)"/>
    </pattern>
    <image id="image0_1461_7549" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};